import MobileMenuBottomNavigation from '@/components/Header/MobileMenuBottomNavigation';
import MobileMenuPrimaryNavigation from '@/components/Header/MobileMenuPrimaryNavigation';
import MobileMenuUtilityNavigation from '@/components/Header/MobileMenuUtilityNavigation';
import { HeaderNavigationItem, HeaderUserMenuItem } from '@/components/Header/navigation';
import { UserRole } from '@/models/User';
import { useAuth } from '@/modules/auth/contexts/AuthContext';
import { HomePath } from '@/routing/paths';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Link } from 'react-router-dom';

interface MobileMenuProps {
  open: boolean;
  close: () => void;
  menu: HeaderNavigationItem[];
  userMenu: HeaderUserMenuItem[];
  cartItemCount: number;
}

const MobileMenu = ({ open, close, menu, userMenu, cartItemCount }: MobileMenuProps) => {
  const { role } = useAuth();

  const showCartActions = role === UserRole.StoreManager;

  return (
    <Dialog as="div" className="lg:hidden" open={open} onClose={close}>
      <div className="fixed inset-0 z-10" />
      <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-4 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
        <div className="flex items-center justify-between min-h-14">
          <Link to={HomePath} onClick={close} className="-m-1.5 flex gap-2 p-1.5">
            <img className="h-8 w-auto" src="/logo.svg" alt="" />
            <div className="flex">
              <span className="self-center text-[16px] font-semibold">Simpler</span>
              <span className="self-center text-[16px] font-semibold">Supply</span>
            </div>
          </Link>
          <MobileMenuUtilityNavigation
            showCartButton={showCartActions}
            close={close}
            cartItemCount={cartItemCount}
          />
        </div>
        <div className="mt-6 flow-root">
          <div className="-my-6 divide-y divide-gray-500/10">
            <MobileMenuPrimaryNavigation menu={menu} onNavigate={close} />
            <MobileMenuBottomNavigation
              role={role}
              showCartLink={showCartActions}
              close={close}
              userMenu={userMenu}
            />
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  );
};

export default MobileMenu;
